import { Paper, styled } from '@mui/material';

export const StyledPaper = styled(Paper)({
  maxWidth: 430,
});
